import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tryout-fully-paid-members',
  templateUrl: './tryout-fully-paid-members.component.html',
  styleUrls: ['./tryout-fully-paid-members.component.css']
})
export class TryoutFullyPaidMembersComponent implements OnInit {

  @Input() NoOfFullyPaidMembers: string;
  @Output() filterMembersEvent = new EventEmitter();

  program_status = '';

  constructor() { }

  ngOnInit() {
  }

  filterMemberListing(value) {
    this.program_status = value;
    this.filterMembersEvent.emit(this.program_status);
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-fully-paid-members/tryout-fully-paid-members.component.ts